export type IGeocodeResponse  = {
  results: Array<IGeocodeResult>;
}

export interface IGeocodeResult {
  formatted_address: string;
  geometry: IGeometryLocation;
  address_components: Array<IAddressComponent>;
  place_id: string;
}

export interface IGeometryLocation {
  location: {
    lat: number;
    lng: number;
  }
}

export interface IAddressComponent {
  long_name: string;
  short_name: string;
  types: Array<string>;
}
